import React from "react";
import Header from "../components/Header";
import { ContactBanner, ContactForm } from "../components/ContactComp";
import Footer from "../components/Footer";

const ContactPage = () => {
  return (
    <>
    <title>Contact Us</title>
      <Header />
      <ContactBanner />
      <ContactForm />
      <Footer />
    </>
  );
};

export default ContactPage;
